'use client'

import React, { createContext, useContext } from 'react'
import { I18nextProvider, initReactI18next, TFunction } from 'react-i18next'

import { createInstance } from 'i18next'

const TranslationContext = createContext<TFunction | undefined>(undefined)

export const useTranslation = () => {
  const context = useContext(TranslationContext)
  if (!context) {
    throw new Error('useTranslation must be used within a TranslationProvider')
  }
  return context
}

interface TranslationProviderProps {
  children: React.ReactNode
  content: any
  locale: string
}

const createTranslationInstance = (content: any, locale: string) => {
  const _i18Instance = createInstance()
  _i18Instance.use(initReactI18next).init({
    debug: false,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    lng: locale,
    resources: {},
  })
  _i18Instance.addResourceBundle(locale.substring(0, 2), 'translation', content, true, true)
  return _i18Instance
}

export const TranslationProvider: React.FC<TranslationProviderProps> = ({ children, content, locale }) => {
  const instance = createTranslationInstance(content, locale)

  return (
    <I18nextProvider i18n={instance}>
      <TranslationContext.Provider value={instance?.getFixedT(locale)}>{children}</TranslationContext.Provider>
    </I18nextProvider>
  )
}
